<template>
  <div class="col-sm-12">
    <div class="card custom-card">

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div v-else>

        <!-- Vehicle Type Dropdown -->
        <div class="form-group">
          <label for="vehicleType" class="block mb-2 font-semibold">
            Vehicle Type : <span class="text-red-500">*</span>
          </label>
          <select
              v-model="vehicleType"
              id="vehicleType"
              class="custom-select"
              :disabled="isSaving"
          >
            <option disabled value="">Select Vehicle Type</option>
            <option v-for="type in vehicleTypeList" :key="type.id" :value="type.id">
              {{ type.vehicle_type }}
            </option>
          </select>
        </div>

        <!-- Vehicle No Input -->
        <div class="form-group">
          <label for="vehicleNo" class="block mb-2 font-semibold">
            Vehicle No : <span class="text-red-500">*</span>
          </label>
          <input
              type="text"
              id="vehicleNo"
              v-model="vehicleNo"
              placeholder="Enter Vehicle No"
              class="name-input"
              :disabled="isSaving"
          />
        </div>

        <!-- Active Toggle -->
        <div class="form-group toggle-container">
          <label for="isActive" class="form-label">Is Active :</label>
          <div class="toggle-wrapper">
            <label class="toggle-switch" :class="{ 'active': isActive, 'inactive': !isActive }">
              <input type="checkbox" id="isActive" v-model="isActive" :disabled="isSaving" hidden />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end action-buttons">
          <button
              type="button"
              class="btn btn-danger"
              @click="Cancel"
              :disabled="isSaving"
          >
            Cancel
          </button>
          <button
              type="button"
              class="btn btn-success save-button"
              @click="updateVehicle"
              :disabled="isSaving || !isFormValid"
          >
            <span v-if="!isSaving">Update</span>
            <div v-else class="loading-indicator">
              <span class="spinner"></span>
              <span>Updating...</span>
            </div>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { getVehicleTypeList, getVehicleDetailsById, updateVehicleDetails } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),
      router: useRouter(),
      vehicleId: this.$route.params.id || null,
      vehicleTypeList: [],
      vehicleType: "",
      vehicleNo: "",
      isActive: true,
      isSaving: false,
      loading: false,
    }
  },

  computed: {
    isFormValid() {
      return this.vehicleType && this.vehicleNo.trim();
    }
  },

 
async created() {
  this.vehicleId = this.$route.params.id;
  await this.loadVehicleTypeList();   // ← wait for types to load first
  await this.loadVehicleDetails();    // ← then load vehicle data
},

methods: {
  async loadVehicleTypeList() {
    try {
      const response = await getVehicleTypeList(this.token);
      this.vehicleTypeList = response.data.data || [];
    } catch (error) {
      console.error('Error fetching vehicle type list:', error);
    }
  },

  async loadVehicleDetails() {
    this.loading = true;
    try {
      const response = await getVehicleDetailsById(this.vehicleId, this.token);
      const vehicleData = response.data.data;

      if (vehicleData) {
        this.vehicleType = vehicleData.vehicle_type_id;  // "2" from API
        this.vehicleNo   = vehicleData.vehicle_no;       // "ZX-9034" from API
        this.isActive    = vehicleData.is_active === "1";
      }

      console.log("vehicleType set to:", this.vehicleType);
      console.log("vehicleNo set to:", this.vehicleNo);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    } finally {
      this.loading = false;
    }
  },

    async updateVehicle() {
      if (!this.vehicleType) {
        useToast().error("Please select a vehicle type.");
        return;
      }

      if (!this.vehicleNo.trim()) {
        useToast().error("Please enter a vehicle number.");
        return;
      }

      this.isSaving = true;
      let idToUse = this.profileId;
      if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
        idToUse = this.reportingProfileId;
      }

      const payload = {
        profile_id: idToUse,
        vehicle_type_id: this.vehicleType,
        vehicle_no: this.vehicleNo,
        is_active: this.isActive ? "1" : "0",
      };

      try {
        await updateVehicleDetails(this.vehicleId, this.token, payload);
        useToast().success("Vehicle details updated successfully!");
        this.$router.push({ path: "/distributor-vehicles" });
      } catch (error) {
        console.error("Error response:", error.response);
        useToast().error("Failed to update vehicle details. Please try again.");
      } finally {
        this.isSaving = false;
      }
    },

    Cancel() {
      if (!this.isSaving) {
        this.$router.push({ path: "/distributor-vehicles" });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 5px;
  padding: 16px;
}

.custom-select {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.name-input {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;

  .form-label {
    margin-bottom: 0;
    font-weight: 500;
  }
}

.toggle-wrapper {
  display: flex;
  align-items: center;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &.active .toggle-slider {
    background-color: #28a745;

    &::before {
      transform: translateX(24px);
    }
  }

  &.inactive .toggle-slider {
    background-color: #dc3545;

    &::before {
      transform: translateX(0);
    }
  }
}

.toggle-slider {
  width: 50px;
  height: 26px;
  background-color: #ccc;
  border-radius: 34px;
  position: relative;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

.action-buttons {
  padding: 16px;
  gap: 12px;

  .btn {
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    min-width: 100px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.save-button {
  position: relative;
  min-width: 120px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.text-red-500 {
  color: #dc3545;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}

@media (max-width: 768px) {
  .custom-card {
    padding: 16px;
  }

  .form-group {
    padding: 12px;
  }
}
</style>s